import { percentualDe, type Centavos } from './dinheiro.js';

/**
 * Split de recebimento aplicado pelo gateway (Asaas) sobre o valor líquido de cada cobrança.
 *
 *   70% Academia da Prosperidade e da Vida
 *   30% RREVELA
 *
 * **Quem é o titular da conta importa.** A conta principal do Asaas é da **RREVELA**, que é
 * dona da `apiKey` e recebe o pagamento primeiro. Por isso o item de `split` declarado em
 * cada cobrança é o da **Academia** (70%) — os 30% da RREVELA ficam na conta principal por
 * diferença, sem item de split correspondente.
 *
 * Inverter isso manda 70% para o lado errado. Se um dia a titularidade mudar, mude aqui,
 * em `apps/api/src/asaas/cliente.ts` e no nome do campo do segredo, tudo junto.
 */
export const PERCENTUAL_ACADEMIA = 70;
export const PERCENTUAL_RREVELA = 30;

/** Percentual que vai como item de split na cobrança — a parte da Academia. */
export const PERCENTUAL_DO_SPLIT = PERCENTUAL_ACADEMIA;

export interface RateioPrevisto {
  bruto: Centavos;
  academia: Centavos;
  rrevela: Centavos;
  /** Parcela que sai da conta principal via split. Hoje é a da Academia. */
  split: Centavos;
}

/**
 * Rateio **previsto** sobre o valor bruto, para exibição no cockpit.
 * O valor efetivamente creditado é calculado pelo Asaas sobre o líquido (bruto menos
 * taxas do gateway) e chega pelo webhook — use sempre o número do webhook para conciliação.
 */
export function rateioPrevisto(bruto: Centavos): RateioPrevisto {
  const academia = percentualDe(bruto, PERCENTUAL_ACADEMIA);
  return { bruto, academia, rrevela: bruto - academia, split: academia };
}
